import React from 'react';
import { AuthenticationProvider } from './Authentication';
import { MessageProvider } from './Message';
import { SchemaProvider } from './Schema';

const GlobalStateProvider: React.FC = ({ children }) => {
  return (
    <MessageProvider>
      <AuthenticationProvider>
        <SchemaProvider>{children}</SchemaProvider>
      </AuthenticationProvider>
    </MessageProvider>
  );
};

export default GlobalStateProvider;
